import Popup from './index.vue'
import Drawer from './drawer.vue'

Popup.install = Vue => {
  Vue.component(Popup.name, Popup)
}

Drawer.install = Vue => {
  Vue.component(Drawer.name, Drawer)
}

export {Popup, Drawer}



// WEBPACK FOOTER //
// ./src/components/popup/index.js